export const STATUS_MESSAGE_IDS = {
  ANALYSING_END: "ANALYSING_END",
  ANALYSING_UPLOAD_DOCUMENTATION: "ANALYSING_UPLOAD_DOCUMENTATION",
  ANALYSING_PENDING_APPROVAL: "ANALYSING_PENDING_APPROVAL",
  ANALYSING_DOCUMENTS_UPLOADED: "ANALYSING_DOCUMENTS_UPLOADED",
  ANALYSING_SIGNATURE_NOT_AVAILABLE: "ANALYSING_SIGNATURE_NOT_AVAILABLE",
  PREAPPROVED_SIGNATURE_REDIRECT: "PREAPPROVED_SIGNATURE_REDIRECT",
  PREAPPROVED_SIGNATURE_REDIRECT_NO_DOCS_NEEDED:
    "PREAPPROVED_SIGNATURE_REDIRECT_NO_DOCS_NEEDED",
  PREAPPROVED_DETACHED_SIGN_END: "PREAPPROVED_DETACHED_SIGN_END",
  PREAPPROVED_DOCS_AND_SIGNATURE_REDIRECT:
    "PREAPPROVED_DOCS_AND_SIGNATURE_REDIRECT",
  CONTRACT_SIGNED_END: "CONTRACT_SIGNED_END",
  CONTRACT_SIGNED_NO_DOCS_NEEDED_END: "CONTRACT_SIGNED_NO_DOCS_NEEDED_END",
  CONTRACT_SIGNED_DOCS_NEEDED: "CONTRACT_SIGNED_DOCS_NEEDED",
  APPROVED_END: "APPROVED_END",
  DENIED_END: "DENIED_END",
  DENIED_AUTO_CPC: "DENIED_AUTO_CPC",
  PREAPPROVED_LOADING_REMAINING_ACTIONS:
    "PREAPPROVED_LOADING_REMAINING_ACTIONS",
  LOAN_ONBOARDINGS_ARE_NOT_COMPLETED: "LOAN_ONBOARDING_ARE_NOT_COMPLETED",
  LENDER_HAS_BEEN_SELECTED_UPLOAD_DOCUMENTATION:
    "LENDER_HAS_BEEN_SELECTED_UPLOAD_DOCUMENTATION",
  LENDER_HAS_BEEN_SELECTED_DOCUMENTS_UPLOADED:
    "LENDER_HAS_BEEN_SELECTED_DOCUMENTS_UPLOADED",
  PREAPPROVED_DOCUMENTS_UPLOADED_SIGNATURE_NOT_AVAILABLE:
    "PREAPPROVED_DOCUMENTS_UPLOADED_SIGNATURE_NOT_AVAILABLE",
  INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_FOR_SIGNATURE:
    "INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_FOR_SIGNATURE",
  LENDER_HAS_BEEN_SELECTED_PENDING_DOWN_PAYMENT_UPLOAD_DOCUMENTATION:
    "LENDER_HAS_BEEN_SELECTED_PENDING_DOWN_PAYMENT_UPLOAD_DOCUMENTATION",
  LENDER_HAS_BEEN_SELECTED_VIDEO_ID_PENDING:
    "LENDER_HAS_BEEN_SELECTED_VIDEO_ID_PENDING",
};
